import { render, staticRenderFns } from "./ModelProductList.vue?vue&type=template&id=6054feea&"
import script from "./ModelProductList.vue?vue&type=script&lang=js&"
export * from "./ModelProductList.vue?vue&type=script&lang=js&"
import style0 from "./ModelProductList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports